import { IonSkeletonText, IonSlide, IonSlides } from "@ionic/react";
import classNames from "classnames/bind";
import React from "react";
import styles from "./StoriesBar.module.scss";

const skeletonItems = [...Array(16).keys()];
const cx = classNames.bind(styles);

const sliderConfig = {
  spaceBetween: 16,
  breakpoints: {
    1024: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
    720: {
      slidesPerView: 6,
      slidesPerGroup: 6,
    },
    768: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
    680: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    640: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    480: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    320: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};

const StoriesBarSkeleton = () => {
  return (
    <IonSlides options={sliderConfig}>
      {skeletonItems.map((_, key) => (
        <IonSlide key={key}>
          <IonSkeletonText animated={true} className={cx("thumb__skeleton")} key={key} />
        </IonSlide>
      ))}
    </IonSlides>
  );
};

export default StoriesBarSkeleton;
